/**
 * Icon name -> Hugeicon, for the shared <Icon name="..." /> component.
 * Covers the historic icon names used across the dashboard (nav, command palette,
 * agent types) so callers keep passing names while every glyph comes from Hugeicons.
 */
import {
  Add01Icon,
  AddCircleIcon,
  AffiliateIcon,
  AiBookIcon,
  AiBrain01Icon,
  AiMagicIcon,
  Agreement02Icon,
  Alert02Icon,
  AlertCircleIcon,
  ArrowDataTransferHorizontalIcon,
  ArrowDown01Icon,
  ArrowLeft01Icon,
  ArrowReloadHorizontalIcon,
  ArrowRight01Icon,
  ArrowRight02Icon,
  Book02Icon,
  BookOpen01Icon,
  BubbleChatIcon,
  Calendar03Icon,
  CalendarCheckIn01Icon,
  Cancel01Icon,
  CarouselHorizontalIcon,
  ChartBarLineIcon,
  ChartHistogramIcon,
  ChartIncreaseIcon,
  ChartLineData01Icon,
  ChartLineData02Icon,
  CheckListIcon,
  CheckmarkBadge01Icon,
  CheckmarkCircle02Icon,
  Clock01Icon,
  Comment01Icon,
  ComputerIcon,
  Copy01Icon,
  CustomerSupportIcon,
  DatabaseIcon,
  Delete02Icon,
  Dollar01Icon,
  Download04Icon,
  DragDropVerticalIcon,
  Facebook01Icon,
  File01Icon,
  File02Icon,
  FileExportIcon,
  FilterHorizontalIcon,
  FloppyDiskIcon,
  Folder01Icon,
  FormIcon,
  Globe02Icon,
  GoogleIcon,
  GridViewIcon,
  HelpCircleIcon,
  HelpSquareIcon,
  HierarchySquare02Icon,
  HistoryIcon,
  Image01Icon,
  InboxIcon,
  InformationCircleIcon,
  Layout01Icon,
  LeftToRightListBulletIcon,
  Link01Icon,
  Link04Icon,
  Loading03Icon,
  Location01Icon,
  Logout03Icon,
  MagicWand01Icon,
  Mail01Icon,
  MailAdd01Icon,
  MailRemove01Icon,
  Megaphone01Icon,
  Menu01Icon,
  Message01Icon,
  MinusSignCircleIcon,
  MinusSignIcon,
  Moon02Icon,
  MoreVerticalIcon,
  PaintBoardIcon,
  ParagraphIcon,
  PauseCircleIcon,
  PauseIcon,
  PencilEdit02Icon,
  PinIcon,
  PlayCircleIcon,
  PlayIcon,
  Recycle03Icon,
  RefreshIcon,
  RepeatIcon,
  ReplyIcon,
  RoboticIcon,
  Rocket01Icon,
  RotateLeft01Icon,
  RotateRight01Icon,
  Route01Icon,
  Search01Icon,
  SearchList01Icon,
  SentIcon,
  SeoIcon,
  Settings02Icon,
  Shield01Icon,
  SidebarLeft01Icon,
  SidebarRight01Icon,
  SlidersHorizontalIcon,
  SmartPhone01Icon,
  SourceCodeIcon,
  SparklesIcon,
  SquareLock02Icon,
  StarIcon,
  Sun03Icon,
  Tag01Icon,
  Target01Icon,
  Target02Icon,
  TextAlignCenterIcon,
  TextFontIcon,
  ThumbsDownIcon,
  ThumbsUpIcon,
  Tick02Icon,
  Undo02Icon,
  Upload04Icon,
  UserIcon,
  UserMultipleIcon,
  UserStar01Icon,
  VideoReplayIcon,
  ViewIcon,
  ViewOffSlashIcon,
  VolumeHighIcon,
  WhatsappIcon,
  WordpressIcon,
  YoutubeIcon,
  ZoomInAreaIcon,
  ZoomOutAreaIcon,
} from '@hugeicons/core-free-icons';

const ICON_MAP = {
  advertiserAdOn: Megaphone01Icon,
  affiliateLink: AffiliateIcon,
  agents: AiBrain01Icon,
  AIIcon: AiMagicIcon,
  AimOutlined: Target02Icon,
  AIStarOutlined: SparklesIcon,
  ApartmentOutlined: HierarchySquare02Icon,
  ApproveOutlined: CheckmarkBadge01Icon,
  AppstoreOutlined: GridViewIcon,
  AppStoreOutlined: GridViewIcon,
  ArrowRightLinear: ArrowRight02Icon,
  ArrowRightOutlined: ArrowRight02Icon,
  BarChartOutlined: ChartHistogramIcon,
  BarsOutlined: LeftToRightListBulletIcon,
  BgColorsOutlined: PaintBoardIcon,
  CalendarOutlined: Calendar03Icon,
  CaretDownOutlined: ArrowDown01Icon,
  CaretRightOutlined: ArrowRight01Icon,
  Carousel: CarouselHorizontalIcon,
  ChatFilled: BubbleChatIcon,
  CheckCircleFilled: CheckmarkCircle02Icon,
  CheckCircleOutlined: CheckmarkCircle02Icon,
  CheckOutlined: Tick02Icon,
  ClockCircleOutlined: Clock01Icon,
  ClockOutlined: Clock01Icon,
  CloseOutlined: Cancel01Icon,
  CodeOutlined: SourceCodeIcon,
  CommentOutlined: Comment01Icon,
  connection: Agreement02Icon,
  CopyOutlined: Copy01Icon,
  CrossLinear: Cancel01Icon,
  CustomerServiceOutlined: CustomerSupportIcon,
  dataExplorerAgent: DatabaseIcon,
  DeleteOutlined: Delete02Icon,
  DesktopOutlined: ComputerIcon,
  DislikeFilled: ThumbsDownIcon,
  DislikeOutlined: ThumbsDownIcon,
  Docs: Book02Icon,
  DollarSignOutlined: Dollar01Icon,
  DownloadOutlined: Download04Icon,
  dynamicForm: FormIcon,
  EditOutlined: PencilEdit02Icon,
  emailCollection: MailAdd01Icon,
  EmailOutlined: Mail01Icon,
  EnvironmentOutlined: Location01Icon,
  ExceptionOutlined: FileExportIcon,
  ExclamationCircleFilled: AlertCircleIcon,
  ExclamationCircleOutlined: AlertCircleIcon,
  EyeInvisibleOutlined: ViewOffSlashIcon,
  EyeOutlined: ViewIcon,
  facebookOutlined: Facebook01Icon,
  FallbackFilled: Route01Icon,
  FaqGuideline: HelpSquareIcon,
  FileOutlined: File01Icon,
  FileTextOutlined: File02Icon,
  FilterOutlined: FilterHorizontalIcon,
  FolderOutlined: Folder01Icon,
  FontLinear: TextFontIcon,
  FundOutlined: ChartLineData02Icon,
  GlobalOutlined: Globe02Icon,
  googleOutlined: GoogleIcon,
  HistoryOutlined: HistoryIcon,
  HolderOutlined: DragDropVerticalIcon,
  InboxOutlined: InboxIcon,
  InfoCircleOutlined: InformationCircleIcon,
  InfoCircleOutlinedRed: InformationCircleIcon,
  JustifyCenterLinear: TextAlignCenterIcon,
  knowledgeAgent: AiBookIcon,
  LeftOutlined: ArrowLeft01Icon,
  LikeFilled: ThumbsUpIcon,
  LikeOutlined: ThumbsUpIcon,
  LineChartOutlined: ChartLineData01Icon,
  LinkOutlined: Link01Icon,
  LinkOutlined2: Link04Icon,
  ListenFilled: VolumeHighIcon,
  LoadingOutlined: Loading03Icon,
  LocationOutlined: Location01Icon,
  LockNormalOutlined: SquareLock02Icon,
  LockOutlined: SquareLock02Icon,
  LogoutOutlined: Logout03Icon,
  MagicPenOutlined: MagicWand01Icon,
  MailOutlined: Mail01Icon,
  MenuFoldOutlined: SidebarLeft01Icon,
  MenuOutlined: Menu01Icon,
  MenuUnfoldOutlined: SidebarRight01Icon,
  MessageOutlined: Message01Icon,
  MinusInCircleoutlined: MinusSignCircleIcon,
  MinusOutlined: MinusSignIcon,
  MobileOutlined: SmartPhone01Icon,
  MoonOutlined: Moon02Icon,
  MoreOutlined: MoreVerticalIcon,
  NoEmail: MailRemove01Icon,
  ParagraphLinear: ParagraphIcon,
  PauseCircleOutlined: PauseCircleIcon,
  PauseFilled: PauseIcon,
  PauseOutlined: PauseIcon,
  personalizationAgent: UserStar01Icon,
  PictureOutlined: Image01Icon,
  PlayCircleOutlined: PlayCircleIcon,
  PlayFilled: PlayIcon,
  PlayOutlined: PlayIcon,
  PlayVideoOutlined: VideoReplayIcon,
  PlusCircleOutlined: AddCircleIcon,
  PlusInCircleOutlined: AddCircleIcon,
  PlusOutlined: Add01Icon,
  polling: ChartBarLineIcon,
  PushPinnedOutlined: PinIcon,
  qualification: Target01Icon,
  QuestionOutlined: HelpCircleIcon,
  recirculation: RepeatIcon,
  RecycleArrowsOutlined: Recycle03Icon,
  ReferenceActiveOutlined: BookOpen01Icon,
  ReferenceOutlined: BookOpen01Icon,
  RefreshOutlined: RefreshIcon,
  ReloadOutlined: RefreshIcon,
  researchPartner: SearchList01Icon,
  ResumeFilled: PlayCircleIcon,
  RightOutlined: ArrowRight01Icon,
  RiseOutlined: ChartIncreaseIcon,
  RobotOutlined: RoboticIcon,
  RocketOutlined: Rocket01Icon,
  RocketTwoTone: Rocket01Icon,
  RotateLeftOutlined: RotateLeft01Icon,
  RotateRightOutlined: RotateRight01Icon,
  RuleChecker: CheckListIcon,
  SaveOutlined: FloppyDiskIcon,
  ScheduleOutlined: CalendarCheckIn01Icon,
  ScreenOutlined: Layout01Icon,
  SearchOulined: Search01Icon,
  SearchOutlined: Search01Icon,
  SendOutlined: SentIcon,
  seoOptimizer: SeoIcon,
  SettingOutlined: Settings02Icon,
  ShieldFilled: Shield01Icon,
  SidebarOutlined: SidebarLeft01Icon,
  smartReply: ReplyIcon,
  sra: BookOpen01Icon,
  StarFilled: StarIcon,
  StarOutlined: StarIcon,
  SunOutlined: Sun03Icon,
  SwapOutlined: ArrowDataTransferHorizontalIcon,
  SyncOutlined: ArrowReloadHorizontalIcon,
  tagSuggestor: Tag01Icon,
  TeamOutlined: UserMultipleIcon,
  TogglesOutline: SlidersHorizontalIcon,
  UndoOutlined: Undo02Icon,
  UploadOutlined: Upload04Icon,
  UserFilled: UserIcon,
  UserGroupOutlined: UserMultipleIcon,
  UserOutlined: UserIcon,
  WarningOutlined: Alert02Icon,
  WhatsAppOutlined: WhatsappIcon,
  wordpress: WordpressIcon,
  YoutubeFilled: YoutubeIcon,
  ZoomInOutlined: ZoomInAreaIcon,
  ZoomOutOutlined: ZoomOutAreaIcon,
};

export const SOLID_ICON_NAMES = new Set([
  'LikeFilled',
  'DislikeFilled',
  'StarFilled',
  'PauseFilled',
  'PlayFilled',
]);

export default ICON_MAP;
